'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable no-use-before-define */


exports.getOperations = getOperations;
exports.getParametersForMethod = getParametersForMethod;
exports.getDefaultValuesFromSwagger = getDefaultValuesFromSwagger;
exports.getDefaultOrOverriddenValuesFromSwagger = getDefaultOrOverriddenValuesFromSwagger;
exports.swaggerPathToExpress = swaggerPathToExpress;
exports.getBrowserUrlLocation = getBrowserUrlLocation;
exports.deref = deref;
exports.getDefaultsFromJSONSchema = getDefaultsFromJSONSchema;
exports.generateNumber = generateNumber;
exports.buildArrayQueryString = buildArrayQueryString;
exports.getDefaultsFromSwagger = getDefaultsFromSwagger;
exports.expandPath = expandPath;
exports.getConsumes = getConsumes;
exports.getProduces = getProduces;
exports.getParameters = getParameters;

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _jsonPointer = require('@axway/json-pointer');

var _jsonPointer2 = _interopRequireDefault(_jsonPointer);

var _randexp = require('randexp');

var _randexp2 = _interopRequireDefault(_randexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Randomness is unncesarry and hard to test.
// still makes a valid string from a regex but this time it is at least predictable.
_randexp2.default.prototype.randInt = function (from) {
	return from;
};

var PATH_PATTERN = /(?:\{.*?\})/g;
var INTERNAL_REF_PATTERN = /^#\//;

/**
 * Gets the operations defined by a path in a swagger document.
 * Derefences $ref to paths object if it exists, and ignores any other defined paths
 *
 * @param {object} swagger - swagger doc
 * @param {object} path - the path to get operations for
 * @returns {object} dereferenced paths object or
 */
function getOperations(swagger, path) {
	if (!swagger || !swagger.paths[path]) {
		return;
	}
	var operations = swagger.paths[path];
	if (operations.$ref) {
		if (INTERNAL_REF_PATTERN.test(operations.$ref)) {
			return _jsonPointer2.default.get(swagger, operations.$ref.substring(1));
		} else {
			// don't do anything with refs that aren't internal
			throw new Error('Cannot dereference Path Item Object at $.paths[\'' + path + '\'].$ref');
		}
	}
	var retOperations = _extends({}, operations);
	return retOperations;
}

// Merges a number of arrays of parameters and removes duplicates (matching 'name' and 'in')
// The last matching parameters in the order they are passed in will win.
function _mergeParameters() {
	var _ref;

	var map = new Map();
	var params = (_ref = []).concat.apply(_ref, arguments);
	for (var i = 0; i < params.length; i++) {
		if (params[i]) {
			map.set(params[i].name + '-' + params[i].in, params[i]);
		}
	}
	return [].concat(_toConsumableArray(map.values()));
}

/**
 * Merges method parameters from path item parameter list, and also dereferences any from the
 * global parameter list to produce a single parameter list that can be used as a source of
 * truth for the method.
 *
 * The path item parameters are defined:
 *     | A list of parameters that are applicable for all the operations described under
 *     | under this path. These parameters can be overridden at the operation
 *     | level, but cannot be removed there.
 * Source: https://github.com/OAI/OpenAPI-Specification/blob/master/versions/2.0.md#path-item-object
 *
 * @param {object} swagger - The swagger document to convert
 * @param {string} path - the path to get params for
 * @param {string} verb - the verb to get params for
 * @param {string|array} location - Optional string or array of strings to filter the parameters
 * @returns {array} a list of dereferenced parameters from the verb/method
 */
function getParametersForMethod(swagger, path, verb, location) {
	var operations = void 0;
	try {
		operations = getOperations(swagger, path);
	} catch (e) {
		console.error(e);
		return [];
	}

	if (!operations || !operations[verb]) {
		return [];
	}

	var method = operations[verb];

	// A list of parameters that are applicable for all the operations described
	// under this path. These parameters can be overridden at the operation
	// level, but cannot be removed there.
	var pathItemParameters = operations.parameters && operations.parameters.map(function (param, i) {
		if (param.$ref) {
			// dereference global parameter
			if (INTERNAL_REF_PATTERN.test(param.$ref)) {
				return _jsonPointer2.default.get(swagger, param.$ref.substring(1));
			} else {
				// don't do anything with refs that aren't internal
				throw new Error('Cannot dereference Parameter Object at $.paths[\'' + path + '\'].parameters[' + i + '].$ref');
			}
		}
		return Object.assign({}, param);
	});

	// dereference any method parameters
	var parameters = (method.parameters || []).map(function (param, i) {
		if (!param.$ref) {
			return param;
		}
		if (INTERNAL_REF_PATTERN.test(param.$ref)) {
			return _jsonPointer2.default.get(swagger, param.$ref.substring(1));
		} else {
			// don't do anything with refs that aren't internal
			throw new Error('Cannot dereference Parameter Object at $.paths[\'' + path + '\'][\'' + verb + '\'].parameters[' + i + '].$ref');
		}
	});

	if (pathItemParameters) {
		parameters = _mergeParameters(pathItemParameters, parameters);
	}

	// filter parameters
	if (location) {
		var inArr = Array.isArray(location) ? location : [location];
		parameters = parameters.filter(function (param) {
			return inArr.includes(param.in);
		});

		if (inArr.includes('consumes')) {
			var consumes = getConsumes(method, swagger, path, verb);
			consumes && consumes.length && parameters.push({
				name: 'Content-Type',
				enum: consumes.sort(),
				type: 'string'
			});
		}

		if (inArr.includes('produces')) {
			var produces = getProduces(method, swagger);
			produces && produces.length && parameters.push({
				name: 'Accept',
				enum: produces.sort(),
				type: 'string'
			});
		}
	}

	return parameters;
}

/**
 * Get default values for method parameters in Swagger.
 *
 * @param {Array} parameters - parameters of Swagger method
 * @returns {Array} params - default values of the given parameters
 */
function getDefaultValuesFromSwagger(parameters) {
	var params = [];

	parameters.filter(function (p) {
		return !p.readOnly;
	}).forEach(function (param) {
		params.push({
			name: param.name,
			collectionFormat: param.collectionFormat,
			value: getDefaultsFromSwagger(param),
			type: param.type
		});
	});

	return params;
}

/**
 * Get default values of the required parameters or the passed one into the respective component.
 *
 * Loops trough the parameters and check if the current parameter has overridden values:
 * 	- if it has overridden value - it gets its value
 * 	- if it does not have overridden value and it is required - it get its default value
 * 	- if it does not have overridden value and is not required - it is skipped
 *
 * @param {Array} parameters - parameters of Swagger method
 * @param {object} overrides - passed parameters to the respective component
 * @returns {Array}
 */
function getDefaultOrOverriddenValuesFromSwagger(parameters, overrides) {
	var params = [];

	parameters.filter(function (p) {
		return !p.readOnly;
	}).forEach(function (param) {
		var defaultValue = getDefaultsFromSwagger(param);
		var passedValue = overrides[param.name];

		if (!!passedValue || param.required) {
			params.push({
				name: param.name,
				collectionFormat: param.collectionFormat,
				value: passedValue || defaultValue,
				type: param.type
			});
		}
	});

	return params;
}

/**
 * Rewrites path string from Swagger format `/path/{id}` to Express format `/path/:id`.
 * @public
 * @param {string} str - The swagger path to convert.
 * @return {string} Rewritten string
 */
function swaggerPathToExpress(str) {
	var match = PATH_PATTERN.exec(str);
	while (match !== null) {
		str = str.replace(/{/, ':').replace(/}/, '');
		match = PATH_PATTERN.exec(str);
	}
	return str;
}

function getBrowserUrlLocation() {
	return document.location.toString().replace(/^(.*\/\/[^/?#]*).*$/, '$1');
}

/**
 * Dereference all the $ref of a given schema object.
 *
 * @param {object} doc - object containing the refs. Can be swagger doc
 * @param {object} schema - JSON schema object to be processed
 * @param {number} maxDepth - default 2. Maximum number of refs to resolve
 * @returns {object} - schema object with refs moved inline
 */
function deref(doc, schema) {
	var maxDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

	var str = JSON.stringify(schema);
	var newSchema = JSON.parse(str);
	if ((typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) !== 'object') {
		return schema;
	}

	// If there's a $ref resolve, dereference and return it
	if (newSchema.$ref) {
		// don't dereference if we hit the maximum dereferencing depth
		if (maxDepth > 0) {
			try {
				newSchema = JSON.parse(JSON.stringify(_jsonPointer2.default.get(doc, newSchema.$ref.slice(1))));
				// if we come across a ref, then derefence reducing the depth of recursive searches
				newSchema = deref(doc, newSchema, maxDepth - 1);
			} catch (e) {
				console.log(e);
				// ignoring errors as if definition not found, the schema retains its original value anyway
			}
		}
		return newSchema;
	}

	// handle properties
	if (newSchema.properties) {
		newSchema.type = 'object';
		for (var prop in newSchema.properties) {
			newSchema.properties[prop] = deref(doc, newSchema.properties[prop], maxDepth);
		}
	}
	if (newSchema.items) {
		newSchema.type = 'array';
	}
	// handle sub-schemas
	var _arr = ['items', 'additionalProperties', 'not'];
	for (var _i = 0; _i < _arr.length; _i++) {
		var key = _arr[_i];
		if (newSchema[key]) {
			newSchema[key] = deref(doc, newSchema[key], maxDepth);
		}
	}
	// Handle arrays of sub-schemas
	var derefItem = function derefItem(item) {
		return deref(doc, item, maxDepth);
	};
	var _arr2 = ['allOf', 'oneOf', 'anyOf'];
	for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
		var _key = _arr2[_i2];
		if (newSchema[_key]) {
			newSchema[_key] = newSchema[_key].map(derefItem);
		}
	}
	return newSchema;
}

/**
 * Get a schema object expanded and populated with example values
 */
function getDefaultsFromJSONSchema(schema) {
	if ((typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) !== 'object') {
		return null;
	}

	// prioritise using predefined examples and then move on to types
	if ('example' in schema) {
		return schema.example;
	} else if (schema.enum && schema.enum.length) {
		return schema.enum[0];
	} else if ('default' in schema) {
		// I really don't like using default here. makes sense not to set the parameter
		// but for now, ok.
		return schema.default;
	} else if (schema.allOf) {
		// merge all the schemas into the root generated example
		var example = {};
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = schema.allOf[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var innerSchema = _step.value;

				example = _extends({}, example, getDefaultsFromJSONSchema(innerSchema));
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		return example;
	} else if (schema.oneOf || schema.anyOf) {
		// take the first schema from either of anyOf or oneOf
		var _innerSchema = (schema.oneOf || schema.anyOf)[0];
		return getDefaultsFromJSONSchema(_innerSchema);
	} else if (schema.type === 'object') {
		var _example = {};
		if (schema.properties) {
			Object.keys(schema.properties).forEach(function (prop) {
				_example[prop] = getDefaultsFromJSONSchema(schema.properties[prop]);
			});
		}
		return _example;
	} else if (schema.type === 'array') {
		var _example2 = [];
		if (schema.items) {
			var val = getDefaultsFromJSONSchema(schema.items);
			for (var i = 0; i < (schema.minItems || 1); i++) {
				_example2.push(val);
			}
		}
		return _example2;
	} else if (schema.type === 'integer' || schema.type === 'number') {
		return 0;
	} else if (schema.type === 'boolean') {
		return false;
	} else if (schema.type === 'string') {
		return '';
	} else if (schema.$ref) {
		// anything could work here, and we can't guarantee correctness
		// but object is probably most common for a referenced model.
		return {};
	}
	return null;
}

/**
 * Generate a number which follows a number of rules.
 * Number can be generated from an optional seed which should be an integer >= 0
 */
function generateNumber(min, max, exclusiveMin, exclusiveMax) {
	var multiple = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
	var seed = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

	seed += 1;
	if (min === undefined && max === undefined) {
		min = 1;
		max = 1;
	} else if (min === undefined) {
		// Max is defined
		max = exclusiveMax ? max - 1 : max;
		min = max;
	} else if (max === undefined) {
		// min is defined
		min = exclusiveMin ? min + 1 : min;
		max = Number.MAX_SAFE_INTEGER;
	} else {
		max = exclusiveMax ? max - 1 : max;
		min = exclusiveMin ? min + 1 : min;
	}

	// Find the lowest multiple
	var lowestMultiple = function lowestMultiple(min, multiple) {
		if (min % multiple === 0) {
			return min;
		}
		return min + (multiple - min % multiple);
	};
	// use the seed to modify the value, while keeping it a valid multiple.
	var n = lowestMultiple(min, multiple);
	if (n * (seed % max) > max) {
		return n;
	}
	return n * (seed % max);
}

// Build 1 or more query parameters based on a set of items
function buildArrayQueryString(param, items) {
	// Make a new array of items which is URL safe.
	// NOTE: This will not be valid for every service,
	// because they can all expect different format inputs. We just can't know...
	var mappedItems = (items || []).map(function (i) {
		// the value will be JSON encoded if it's an object
		if ((typeof i === 'undefined' ? 'undefined' : _typeof(i)) === 'object') {
			i = JSON.stringify(i);
		}
		return encodeURIComponent(i);
	});

	// return a string of params with the same name for multi
	if (param.collectionFormat === 'multi') {
		return mappedItems.map(function (item) {
			return param.name + '=' + item;
		}).join('&');
	}

	var result = void 0;
	// For all other collectionFormat types, return one param
	//
	// TODO: is this right for ssv/tsv? should they be encoded since they will screw up the URL?
	//
	switch (param.collectionFormat) {
		case 'ssv':
			result = mappedItems.join('%20'); // URI safe space
			break;
		case 'tsv':
			result = mappedItems.join('%09'); // URI safe tab
			break;
		case 'pipes':
			result = mappedItems.join('|');
			break;
		case 'csv':
		default:
			// default collection format is 'csv'
			result = mappedItems.join(',');
			break;
	}
	return result ? param.name + '=' + result : '';
}

/**
 Get default (or example) values for a given swagger parameter based on its type.
 */
function getDefaultsFromSwagger(param) {
	var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	var val = '';
	if (param.default) {
		val = param.default;
	} else if (param.enum) {
		val = param.enum.length && param.enum[seed % param.enum.length];
	} else if (param.type) {
		switch (param.type) {
			case 'integer':
			case 'number':
				val = generateNumber(param.minimum, param.maximum, param.exclusiveMaximum, param.exclusiveMinimum, param.multipleOf, seed);
				break;
			case 'boolean':
				val = false;
				break;
			case 'string':
				// generate a lowercase character (a-z) the minimum amount of times or follow a preset pattern
				var pattern = param.pattern || '^[a-z]{' + (param.minLength || 1) + '}$';
				val = new _randexp2.default(pattern).gen();
				break;
			case 'array':
				val = getArrayValues(param);
				break;
			case 'file':
				val = 'file.json';
				break;
			default:
				break;
		}
	}
	return val;
}

function getArrayValues(param) {
	// check requirements for items count
	var count = 1;
	if ('minItems' in param) {
		count = param.minItems;
	} else if ('maxItems' in param && param.maxItems === 0) {
		count = 0;
	}
	var items = [];
	for (var i = 0; i < count; i++) {
		var val = getDefaultsFromSwagger(param.items, i);
		items.push(val);
	}
	return items;
}
/**
 * Expand the path, embedding the path parameters and appending the query
 * parameters.
 */
function expandPath(path, pathParams, queryParams) {
	// Format the url
	var expandedPath = path;

	// Format the path params
	if (pathParams && Object.keys(pathParams).length > 0) {
		expandedPath = expandedPath.replace(/{\w+}*/g, function (name) {
			name = name.slice(1, -1);
			var value = pathParams[name] !== undefined && pathParams[name] !== null ? pathParams[name] : '';

			if (!value) {
				throw new Error(name + ' required.');
			}
			return value;
		});
	}

	// Remove duplicate slashes
	expandedPath = expandedPath.replace(/\/{2,}/g, '/');

	// Format the query string
	if (queryParams && Object.keys(queryParams).length > 0) {
		// Omit empty params
		var populatedQueryParams = Object.keys(queryParams).filter(function (key) {
			return queryParams[key] !== undefined && queryParams[key] !== null && queryParams[key] !== '';
		}).reduce(function (prev, key) {
			prev[key] = queryParams[key];
			return prev;
		}, {});
		expandedPath = expandedPath + '?' + _qs2.default.stringify(populatedQueryParams);
	}

	return expandedPath;
}

/**
 * Returns consumes values for the "Content-Type" header based on the method itself or from the swagger definition
 */
function getConsumes(method, doc, path, verb) {
	var consumes = method.consumes || doc.consumes || [];
	var params = getParameters(doc, path, verb);
	if (!consumes.length && params.body) {
		// not explicitly stated in Swagger 2.0 spec, but when the document does not define
		// "consumes", but a method has a body (which requires a JSON schema), then the method
		// has an implicit default "application/json" content type.
		return ['application/json'];
	}
	return consumes;
}

/**
 * Returns produces values for the "Accept" header based on the method itself or from the swagger definition
 */
function getProduces(method, doc) {
	var produces = method.produces || doc.produces;
	if (!produces) {
		// not explicitly stated in Swagger 2.0 spec, but when the "produces" is undefined,
		// then the method has an implicit default "application/json" encoding type.
		return ['application/json'];
	}
	return produces;
}

/**
 * Get the parameters grouped by type.
 */
function getParameters(doc, path, verb) {
	var parameters = getParametersForMethod(doc, path, verb);
	var parameterMap = {};
	if (parameters && parameters.length > 0) {
		parameters.forEach(function (param) {
			parameterMap[param.in] = parameterMap[param.in] || [];
			parameterMap[param.in].push(param);
		});
	}

	return parameterMap;
}
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(PATH_PATTERN, 'PATH_PATTERN', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(INTERNAL_REF_PATTERN, 'INTERNAL_REF_PATTERN', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(getOperations, 'getOperations', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(_mergeParameters, '_mergeParameters', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(getParametersForMethod, 'getParametersForMethod', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(getDefaultValuesFromSwagger, 'getDefaultValuesFromSwagger', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(getDefaultOrOverriddenValuesFromSwagger, 'getDefaultOrOverriddenValuesFromSwagger', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(swaggerPathToExpress, 'swaggerPathToExpress', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(getBrowserUrlLocation, 'getBrowserUrlLocation', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(deref, 'deref', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(getDefaultsFromJSONSchema, 'getDefaultsFromJSONSchema', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(generateNumber, 'generateNumber', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(buildArrayQueryString, 'buildArrayQueryString', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(getDefaultsFromSwagger, 'getDefaultsFromSwagger', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(getArrayValues, 'getArrayValues', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(expandPath, 'expandPath', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(getConsumes, 'getConsumes', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(getProduces, 'getProduces', 'src/components/SwaggerUI/util.js');

	__REACT_HOT_LOADER__.register(getParameters, 'getParameters', 'src/components/SwaggerUI/util.js');
}();

;